export default __webpack_public_path__ + "static/media/wedding-thumbnail-5.df271c8f.jpg";